export async function persistFlexiconSaveResponse({ database, resourceType, response }) {
  const data = await response.json();
  const updated = data.data?.[resourceType];

  if (!(response.ok && data.ok === true && updated?.id)) {
    const error = new Error('Failed to save flexicon');
    error.apiErrors = data.errors;
    throw error;
  }

  if (resourceType === 'user') {
    await database.users.update(String(updated.id), updated);
  }
  if (resourceType === 'workspace') {
    await database.workspaces.put(updated);
  }

  return updated;
}
